/**
 * AMP Cart Integration - Syncs theme cart icon bubble with Upsell by Amp cart updates
 *
 * When Upsell by Amp replaces the cart drawer, the theme's cart icon (#cart-icon-bubble)
 * doesn't update because Amp's cart operations bypass the theme's cart update flow.
 * This script listens for AMP_CART_UPDATED and AMP_CART_LOADED callbacks to refresh
 * the cart icon via Shopify's Section Rendering API.
 */
(function () {
  const CART_ICON_SELECTOR = '#cart-icon-bubble';
  const SECTION_ID = 'cart-icon-bubble';

  function getSectionUrl() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.routes?.cart_url ? window.routes.cart_url.replace(/\/cart\/?$/, '') : '') || '/';
    const base = root.endsWith('/') ? root : root + '/';
    return `${base}?section_id=${SECTION_ID}`;
  }

  function updateCartIconBubble() {
    const cartIcon = document.querySelector(CART_ICON_SELECTOR);
    if (!cartIcon) return;

    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    const sectionUrl = getSectionUrl();

    fetch(sectionUrl)
      .then((response) => {
        if (!response.ok) throw new Error('Section fetch failed');
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const sectionContent = doc.querySelector('[id*="cart-icon-bubble"]') || doc.querySelector('.shopify-section');
        if (sectionContent) {
          cartIcon.innerHTML = sectionContent.innerHTML;
          return;
        }
        throw new Error('No section content found');
      })
      .catch(() => {
        // Fallback: fetch cart JSON and update count manually
        fetch(`${cartUrl}.js`)
          .then((res) => res.json())
          .then((cart) => {
            const bubble = cartIcon.querySelector('.cart-count-bubble');
            const countSpan = bubble?.querySelector('span[aria-hidden="true"]');
            const screenReaderSpan = bubble?.querySelector('.visually-hidden');
            if (cart.item_count === 0) {
              if (bubble) bubble.remove();
            } else {
              if (!bubble) {
                const newBubble = document.createElement('div');
                newBubble.className = 'cart-count-bubble';
                const span = document.createElement('span');
                span.setAttribute('aria-hidden', 'true');
                span.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
                newBubble.appendChild(span);
                const sr = document.createElement('span');
                sr.className = 'visually-hidden';
                sr.textContent = `${cart.item_count} items`;
                newBubble.appendChild(sr);
                cartIcon.appendChild(newBubble);
              } else if (countSpan) {
                countSpan.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
              }
              if (screenReaderSpan) screenReaderSpan.textContent = `${cart.item_count} items`;
            }
          })
          .catch((err) => console.warn('AMP cart integration: failed to update cart icon', err));
      });
  }

  // Store any existing AMP callback so we can chain if needed
  const existingCartUpdated = window.AMP_CART_UPDATED;
  const existingCartLoaded = window.AMP_CART_LOADED;

  window.AMP_CART_UPDATED = function (rawCart, cartTarget) {
    updateCartIconBubble();
    if (typeof existingCartUpdated === 'function') {
      return existingCartUpdated(rawCart, cartTarget);
    }
  };

  window.AMP_CART_LOADED = function (cart) {
    updateCartIconBubble();
    if (typeof existingCartLoaded === 'function') {
      existingCartLoaded(cart);
    }
  };
})();
